module.exports = __webpack_public_path__ + "media/application/icon-reset--red-521e3db1.svg";